import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesDisease = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
https://www.cell.com/cell/pdf/S0092-8674(19)30164-3.pdf (2019)<br /> 
https://www.mdpi.com/1422-0067/22/8/4182 <br /> 
https://medlineplus.gov/genetics/condition/familial-hypertrophic-cardiomyopathy/#causes <br /> 

</div>
)
}